import { useMemo } from 'react';
import Constants from '~/app/Constants';
import { getCompanyByPath, getExternalBaseUrl } from '~/utils/companyUtils';

interface RequiredRoute {
  path: string;
  required: boolean | string;
  allowed?: boolean;
}

interface UseSecurityRedirectParams {
  hasOnboardingError: boolean;
  currentPath: string;
  currentRequiredRoute: RequiredRoute | undefined;
  firstRequiredRoute: RequiredRoute | undefined;
}

export default function useSecurityRedirect({
  hasOnboardingError,
  currentPath,
  currentRequiredRoute,
  firstRequiredRoute,
}: UseSecurityRedirectParams) {
  const isOnCentralizationPage = currentPath.includes(Constants.PagesUrl.CentralizationBaseFragment);
  const isOnCentralizationErrorPage = currentPath === Constants.PagesUrl.CentralizationErrorPage;

  const needsToGoHome = useMemo(() => {
    if (
      currentRequiredRoute && !currentRequiredRoute.required && !currentRequiredRoute.allowed
    ) {
      return getExternalBaseUrl(getCompanyByPath(currentPath)) || Constants.PagesUrl.HomePage;
    }
    return undefined;
  }, [currentPath, currentRequiredRoute]);
  const needsToGoToSecuredRoute = Boolean(!currentRequiredRoute && firstRequiredRoute);
  const needsToGoToCentralizationError = hasOnboardingError && isOnCentralizationPage && !isOnCentralizationErrorPage;

  return {
    needsToGoHome,
    needsToGoToSecuredRoute,
    needsToGoToCentralizationError,
    firstRequiredRoute,
  };
}
